const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/feedback/api-factory');
const serviceFactory = require('../resources/feedback/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app

//send client feedback
  .match(`${p}feedback.getResponseJson[{keys:portfolioId}][{keys:deviceType}][{integers:starRating}][{keys:feedbackCateg}][{keys:feedbackText}][{keys:logoutTriggered}][{keys:clientAdvisorFlag}]`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.getResponseJson(req.params)
      .then(response => res.value(response))
      .catch(res.error)
  )))

  .match(`${p}feedback.checkStarFeedback`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.checkStarFeedback(req.params)
      .then(response => res.value(response))
      .catch(res.error)
  )))

  .match(`${p}feedback.checkUserType`, requests => Promise.all(
       requests.map(({ req, res }) =>
        service.checkUserType(req.params.metaData)
          .then(response => res.value(response))
          .catch(res.error)
  )))

  .match(`${p}feedback.getStarFeedback[{keys:portfolioId}][{keys:deviceType}][{integers:starRating}][{keys:feedbackCateg}][{keys:feedbackText}][{keys:logoutTriggered}][{keys:clientAdvisorFlag}]`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.getStarFeedback(req.params)
      .then(response => res.value(response))
      .catch(res.error)
  )))

  // WMCE-4443, BELOW PATHS CREATED TO MATCH PATHS FOR BP IDS AS BP ID WILL BE INTEGER, BP CONSOLIDATION
  .match(`${p}feedback.getResponseJson[{integers:portfolioId}][{keys:deviceType}][{integers:starRating}][{keys:feedbackCateg}][{keys:feedbackText}][{keys:logoutTriggered}][{keys:clientAdvisorFlag}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getResponseJson(req.params)
       .then(response => res.value(response))
       .catch(res.error)
   )))
   .match(`${p}feedback.getStarFeedback[{integers:portfolioId}][{keys:deviceType}][{integers:starRating}][{keys:feedbackCateg}][{keys:feedbackText}][{keys:logoutTriggered}][{keys:clientAdvisorFlag}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getStarFeedback(req.params)
       .then(response => res.value(response))
       .catch(res.error)
   )));
}

module.exports = addRoutes;
